import { render, staticRenderFns } from "./EventDateListItem.vue?vue&type=template&id=52c6b695&scoped=true&"
import script from "./EventDateListItem.vue?vue&type=script&lang=js&"
export * from "./EventDateListItem.vue?vue&type=script&lang=js&"
import style0 from "./EventDateListItem.vue?vue&type=style&index=0&id=52c6b695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6b695",
  null
  
)

export default component.exports